import type { ProgressBreakpoints } from "../components/calorie-progress-bar/progress-bar-track";
import type { TimeRangeKey } from "../components/time-range-buttons";

type RangeBounds = {
  min: number;
  max: number;
};

export const CALORIE_BALANCE_PROGRESS_BOUNDS: Record<TimeRangeKey, RangeBounds> = {
  day: { min: -500, max: 500 },
  week: { min: -3500, max: 3500 },
  month: { min: -14000, max: 14000 },
};

export const CALORIE_BALANCE_RANGE_BOUNDS: Record<TimeRangeKey, RangeBounds> = {
  day: { min: -100, max: 100 },
  week: { min: -500, max: 1000 },
  month: { min: -2000, max: 5000 },
};

export const getProgressBreakpointsForRange = (range: TimeRangeKey): ProgressBreakpoints => {
  const { min: progressMin, max: progressMax } = CALORIE_BALANCE_PROGRESS_BOUNDS[range];
  const { min: onPlanMin, max: onPlanMax } = CALORIE_BALANCE_RANGE_BOUNDS[range];
  return [progressMin, onPlanMin, 0, onPlanMax, progressMax];
};

export const isCalorieBalanceOutsideRange = (value: number, range: TimeRangeKey) => {
  const { min, max } = CALORIE_BALANCE_RANGE_BOUNDS[range];
  return value < min || value > max;
};
